module.exports = __webpack_public_path__ + "assets/img/config-table-284c81fe.png";